
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import sentry from './plugins/sentry'
import Api from './api/index.js'
import Axios from './core/axios'
import Global from './core/global'
import Utils from './core/utils'
import StorageUtils from './core/storageUtils'
import GjwBaseComponents from './components/gjwBase'
import Tracks from './core/tracks'
import webLogin from './core/webLogin'
import { initTheme } from './core/themeUtil'
import { initRevit } from './initRevit'
import { initWeb } from './initWeb'
import { initGcs } from './initGcs'
import { initDesktop } from './initDesktop'
import './directives/index'
import './assets/css/index.less'
import ElementUI from 'element-ui'
import { message } from './plugins/message'
import './assets/elementThemes/green/theme/index.css'
import i18n from './i18n'

Vue.use(Api)
Vue.use(Axios)
Vue.use(Global)
Vue.use(Tracks)
Vue.use(webLogin)
Vue.use(ElementUI, { size: 'mini', zIndex: 2000 })
Vue.use(GjwBaseComponents)
Vue.prototype.$message = message
Vue.config.productionTip = false

// 根据url参数初始化主题风格, 如果没有，则显示默认风格（默认风格同R平台）
const platform = Utils.getUrlQuery('platform') || StorageUtils.sessionStorage.get('platform') || 'web'
// 根据不同的平台，加载不同的elementUI主题
platform === 'g' || platform === 'cs'
  ? import('@/assets/elementThemes/blue/theme/index.css')
  : import('@/assets/elementThemes/green/theme/index.css')
StorageUtils.sessionStorage.set('platform', platform)
store.commit('setPlatform', platform)
initTheme(platform)

// 取出插件端的插件类型和版本
const softwareCode = Utils.getUrlQuery('softwareCode') || StorageUtils.sessionStorage.get('softwareCode')
let softwareVersion = Utils.getUrlQuery('softwareVersion') || StorageUtils.sessionStorage.get('softwareVersion')
if (platform === 'cs') {
  softwareVersion = Utils.getUrlQuery('novaSoftwareVersion') || StorageUtils.sessionStorage.get('softwareVersion')
}
const language = Utils.getUrlQuery('language') || StorageUtils.sessionStorage.get('language') || 'zh_CN'
// 取出是否正在进行设备选型
const isSelectingEquipment = Utils.getUrlQuery('isSelectingEquipment') === 'true' || StorageUtils.sessionStorage.get('isSelectingEquipment') === 'true'
// 临时添加凯泉水泵独立页面, 取出路由中的bandName
const brandCode = Utils.getUrlQuery('brandCode') || StorageUtils.sessionStorage.get('brandCode')
let initFn = initWeb
if (platform === 'g') {
  if (typeof CefSharp !== 'undefined') { // .NET新插件，使用desktopUtils.js并兼容旧接口调用
    initFn = initDesktop
  } else { // C++旧插件，继续使用gcsUtils.js
    initFn = initGcs
  }
} else if (platform === 'r') {
  initFn = initRevit
} else if (platform === 'cs') {
  initFn = initDesktop
} else {
  initFn = initWeb
}
const payload = { platform, softwareCode, softwareVersion, language, isSelectingEquipment, brandCode }
initFn({ Vue, Store: store }, payload).then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app')
})

